import { render, staticRenderFns } from "./LahanUmumPlantingHoleDetail.vue?vue&type=template&id=56ca398d"
import script from "./LahanUmumPlantingHoleDetail.vue?vue&type=script&lang=js"
export * from "./LahanUmumPlantingHoleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports